import { render, staticRenderFns } from "./CalendarGS.vue?vue&type=template&id=65a3a232&scoped=true&"
import script from "./CalendarGS.vue?vue&type=script&lang=js&"
export * from "./CalendarGS.vue?vue&type=script&lang=js&"
import style0 from "./CalendarGS.vue?vue&type=style&index=0&id=65a3a232&prod&scoped=true&lang=css&"
import style1 from "./CalendarGS.vue?vue&type=style&index=1&id=65a3a232&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a3a232",
  null
  
)

export default component.exports